import { app } from '../../../bootstrap/core';
import { categorizeIncomingDocumentComponent } from './categorizeIncomingDocument.component';
import { DocumentStatusSelectables, DocumentTypeSelectables, ReducedDocumentTypeSelectables } from './categorizeIncomingDocument.constants';
//import './ibanAssign/ibanAssign';
import { InboxIbanService } from './ibanAssign/ibanSearch.service';
import { InboxDocumentService } from '../inbox.document.service';

app.component('categorizeIncomingDocument', categorizeIncomingDocumentComponent)
  .constant('DocumentStatusSelectables', DocumentStatusSelectables)
  .constant('ReducedDocumentTypeSelectables', ReducedDocumentTypeSelectables)
  .constant('DocumentTypeSelectables', DocumentTypeSelectables)
  .service('InboxIbanService', InboxIbanService)
  .service('inboxDocumentService', InboxDocumentService);
